<!-- 汇总统计 -->
<template>
    <div class="content">
        <div class="search-area">
            <el-row :gutter="24">
                <el-col :span="6">
                    <div class="search-area-div">供应商：</div>
                    <el-input v-model="page.supplierName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input>
                </el-col>
                <el-col :span="6">
                    <div class="search-area-div">付款状态：</div>
                    <el-select v-model="page.paymentState" placeholder="请选择" class="ipt-sty" :clearable="true">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                        </el-option> </el-select>
                </el-col>
                <el-col :span="6">
                    <div class="search-area-div">开票状态：</div>
                    <el-select v-model="page.invoiceState" placeholder="请选择" class="ipt-sty" :clearable="true">
                        <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                        </el-option> </el-select>
                </el-col>
                <el-col :span="6" class="t-right">
                    <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
                    <el-button size="medium" type="danger" @click="empty">清空</el-button>
                </el-col>
            </el-row>

        </div>
        <div class="button-area">
            <el-button size="medium" @click="report">导出</el-button>
        </div>
        <div class="back-color-fff p16" style="padding: 16px">
            <el-table :data="summaryData" style="width: 100%; margin-bottom: 20px" border v-loading="loading">
                <el-table-column label="序号" width="60" header-align="center" align="center">
                    <template slot-scope="scope">
                        <!-- {{ scope.$index + 1 }} -->
                        {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="supplierName" label="供应商" header-align="center" align="left" width="250"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="signingFlag" label="签约状态" header-align="center" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.signingFlag | getSigningType }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payableAmount" label="应付款" header-align="center" align="right" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.payableAmount | numDigit }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="paymentState" label="付款状态" header-align="center" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.paymentState | getPaymentState }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="receiptAmount" label="实际到账" header-align="center" align="right" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.receiptAmount | numDigit }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="欠款" header-align="center" align="right" width="150">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.payableAmount - scope.row.receiptAmount) | numDigit }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="invoiceState" label="开票状态" header-align="center" align="center" width="90">
                    <template slot-scope="scope">
                        <span>{{ scope.row.invoiceState | getInvoiceState }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="应开票金额" header-align="center" align="right" width="150" prop="receiptAmount">
                    <template slot-scope="scope">
                        <span>{{ scope.row.receiptAmount | numDigit }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="已开票金额" header-align="center" align="right" width="150" prop="invoiceAmount">
                    <template slot-scope="scope">
                        <span>{{ scope.row.invoiceAmount | numDigit }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="待开票" header-align="center" align="right" width="150">
                    <template slot-scope="scope">
                        <span>{{ (scope.row.receiptAmount - scope.row.invoiceAmount) | numDigit }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
            :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
    </div>
</template>
<script>
export default {
    name: '',
    props: {},
    components: {},
    data() {
        return {
            summaryData: [],
            loading: false,
            page: {
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                totalRows: 0,
                medGuid: this.$store.state.medGuid,
                invoiceState: '',
                supplierName: '',
                paymentState: '',
            },
            //收费状态
            options1: [
                {
                    value: 'Y',
                    label: '已付清',
                },
                {
                    value: 'P',
                    label: '未付清',
                },
                {
                    value: 'N',
                    label: '未付',
                },
            ],
            //开票状态
            options2: [
                {
                    value: '1',
                    label: '全额已开',
                },
                {
                    value: '2',
                    label: '部分已开',
                },
                {
                    value: '3',
                    label: '未开票',
                },
            ],
        };
    },
    computed: {},
    watch: {},
    methods: {
        // 导出
        report() {
            let { invoiceState, supplierName, paymentState, medGuid } = this.page;
            this.api
                .get(
                    `/ms-data-business-service/operating-costs/export-collect-operating-costs-list?` +
                    `medGuid=` +
                    medGuid +
                    `&supplierName=` +
                    supplierName +
                    `&invoiceState=` +
                    invoiceState +
                    `&paymentState=` +
                    paymentState,
                ).then(res => {
                    if (res.data.code == '00000') {
                        this.api
                            .postJsonD(`ms-common-admin-cloud-service/excel/export`, res.data.data).then(res => {
                                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                let fileName = '费用汇总统计';
                                let objectUrl = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.download = fileName;
                                link.href = objectUrl;
                                link.click();
                            })
                    }
                })
        },
        // 搜索
        searchData() {
            let self = this;
            self.loading = true;
            let { invoiceState, supplierName, paymentState, medGuid, pageIndex, pageSize } = self.page;
            self.api
                .get(
                    `/ms-data-business-service/operating-costs/get-collect-operating-costs-list?invoiceState=` +
                    invoiceState +
                    `&medGuid=` +
                    medGuid +
                    `&paymentState=` +
                    paymentState +
                    `&supplierName=` +
                    supplierName +
                    `&pageIndex=` +
                    pageIndex +
                    `&pageSize=` +
                    pageSize
                )
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        self.summaryData = res.data.data.records;
                        self.loading = false;
                        self.page.totalPage = res.data.data.totalPages;
                        self.page.totalRows = res.data.data.totalRows;
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        // 清空
        empty() {
            this.page = {
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                totalRows: 0,
                invoiceState: '',
                medGuid: this.$store.state.medGuid,
                paymentState: '',
                supplierName: '',
            };
            this.searchData();
        },
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.searchData();
        },
        handleCurrentChange(val) {
            this.page.pageIndex = val;
            this.searchData();
        },
    },
    created() {
        this.searchData()
    },
    mounted() { },
    beforeDestroy() { }
};
</script>
<style lang='scss' scoped></style>